














import { Component, Prop, Vue } from 'vue-property-decorator';


@Component({
    name:'PrivacyPolicy',
})

export default class Manage extends Vue {
    
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PrivacyPolicy.vue